import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const Favicon = ({ iconUrl }: { iconUrl: string }) => (
    <Flex
        justifyContent="center"
        alignItems="center"
        width="32px"
        height="32px"
        padding="8px"
        borderRadius="3px"
        background={colorsPalettes.carbon[0]}
        border={`1px solid ${colorsPalettes.carbon[50]}`}
        flexShrink={0}
    >
        <img
            // in case of iconUrl is empty string
            src={iconUrl || undefined}
            alt="favicon"
            data-automation="favicon-image"
        />
    </Flex>
);
